var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 141,
    viewBox: "0 0 151 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.10646,
    cy: 77.5184,
    r: 1.85646,
    fill: "#F41C1C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.41115,
    cy: 49.4062,
    r: 1.85646,
    fill: "#FE0550"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6885,
    cy: 31.3721,
    r: 1.85646,
    fill: "#64054B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.4795,
    cy: 12.8074,
    r: 1.85646,
    fill: "#64054B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.9385,
    cy: 120.482,
    r: 1.85646,
    fill: "#FE0550"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.755,
    cy: 23.4158,
    r: 1.85646,
    fill: "#F41C1C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.7735,
    cy: 19.7029,
    r: 1.85646,
    fill: "#EF96D6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.0781,
    cy: 2.19907,
    r: 1.85646,
    fill: "#F41C1C"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5127,
    cy: 12.8074,
    r: 1.85646,
    fill: "#FE0550"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2793,
    cy: 9.09455,
    r: 1.85646,
    fill: "#EF96D6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.964,
    cy: 9.09455,
    r: 1.85646,
    fill: "#64054B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9658,
    cy: 120.482,
    r: 1.85646,
    fill: "#64054B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.677,
    cy: 41.45,
    r: 1.85646,
    fill: "#64054B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.755,
    cy: 109.874,
    r: 1.85646,
    fill: "#64054B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6885,
    cy: 98.7352,
    r: 1.85646,
    fill: "#64054B"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.268,
    cy: 87.5965,
    r: 1.85646,
    fill: "#F41C1C"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.1143,
    cy: 114.117,
    r: 1.85646,
    fill: "#F41C1C"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.346,
    cy: 57.3625,
    r: 1.85646,
    fill: "#FE0550"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8975,
    cy: 57.3625,
    r: 1.85646,
    fill: "#EF96D6"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.8086,
    cy: 113.587,
    r: 1.85646,
    fill: "#EF96D6"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1231,
    cy: 102.448,
    r: 1.85646,
    fill: "#EF96D6"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.0615,
    cy: 132.682,
    r: 1.85646,
    fill: "#F41C1C"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.9297,
    cy: 33.4937,
    r: 1.85646,
    fill: "#FE0550"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.877,
    cy: 69.5623,
    r: 28.2657,
    fill: "#1C5D99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1031_6391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1461 62.0773L62.6577 78.5657L55.1006 71.0085L57.038 69.0711L62.6577 74.6772L77.2087 60.14L79.1461 62.0773Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.737 69.5622C101.737 88.5553 86.3402 103.952 67.3472 103.952C48.3541 103.952 32.9572 88.5553 32.9572 69.5622C32.9572 50.5692 48.3541 35.1723 67.3472 35.1723C86.3402 35.1723 101.737 50.5692 101.737 69.5622Z",
    stroke: "#1C5D99",
    strokeWidth: 2.82657
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1031_6391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.9767,
    height: 32.9767,
    fill: "white",
    transform: "translate(50.3887 52.6027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.5b3d4ef05d09d493739ebfab3377d2c7.svg";
export { ForwardRef as ReactComponent };